import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: '', // set locale
  fallbackLocale: 'en',
  messages: {}, // set locale messages
})

const loadedLanguages = [] // our default language that is preloaded

/**
 * Beállítja a nyelvet
 *
 * @param lang
 * @return {*}
 */
function setI18nLanguage(lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

/**
 * Az apiról lekért fordításokat beállítja az i18n-nek
 *
 * @param lang
 * @return {Promise<unknown>|Promise<void>}
 */
export function loadLanguageAsync(lang) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }
  return axios.get(`/Portal/api/jsTranslates?lang=${lang}`, {
    headers: {
      buildVersion: __VERSION__,
    },
  })
    .then(response => {
      const msgs = response.data
      loadedLanguages.push(lang)

      i18n.setLocaleMessage(lang, msgs)

      setI18nLanguage(lang)
    })
}
